import React, {useState} from 'react';
import {FaArrowCircleUp} from 'react-icons/fa';
import styled from 'styled-components';
  
const ScrollStyleButton = styled.div`
   position: fixed; 
   width: 100%;
   left: 90%;
   bottom: 80px;
   height: 20px;
   font-size: clamp(28px, 4vmin, 44px);
   z-index: 1;
   cursor: pointer;
   color: white;
`
  
const ScrollButton = () =>{
  
  const [visible, setVisible] = useState(false)
  
  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 300){
      setVisible(true)
    } 
    else if (scrolled <= 300){
      setVisible(false)
    }
  };
  
  const scrollToTop = () =>{
    window.scrollTo({
      top: 0, 
      behavior: 'smooth'
    });
  };
  
  window.addEventListener('scroll', toggleVisible);
  
  return (
    <ScrollStyleButton>
     <FaArrowCircleUp onClick={scrollToTop} 
     style={{display: visible ? 'inline' : 'none'}} />
    </ScrollStyleButton>
  );
}
  
export default ScrollButton;